import {Widget} from '../../core/models';

export class FetchDashboards {
  static readonly type = '[Dashboard] Fetch';

  constructor() {
  }
}


export class AddDashboard {

  static readonly type = '[Dashboard] Add';

  constructor(public payload: any) {
  }
}

export class UpdateDashboard {

  static readonly type = '[Dashboard] Update';

  constructor(public id: number, public payload: any) {
  }
}

export class ReorderDasboards {

  static readonly type = '[Dashboard] Reorder';

  constructor(public id: number, public payload: any, public previousIndex: number, public currentIndex: number) {
  }
}


export class SetActiveDashboard {
  static readonly type = '[Dashboard] SetActive';

  constructor(public id: number) {
  }
}

export class AddWidgetToDashboard {
  static readonly type = '[Dashboard] AddWidget';

  constructor(public id: number, public x: number, public y: number) {
  }
}

export class RemoveWidgetFromDashboard {
  static readonly type = '[Dashboard] RemoveWidget';

  constructor(public id: string, public name: string) {
  }
}

export class EditWidget {
  static readonly type = '[Dashboard] EditWidget';

  constructor(public dashboardId: number, public widget: Widget) {
  }
}

export class CancelEditWidget {
  static readonly type = '[Dashboard] CancelEditWidget';

  constructor() {
  }
}


export class DuplicateWidget {

  static readonly type = '[Dashboard] DuplicateWidget';

  constructor(public id: number, public payload: any) {
  }
}


export class DeleteDashboard {

  static readonly type = '[Dashboard] DeleteDashboard';

  constructor(public id: number, public name: string) {
  }
}


export class SaveWidget {
  static readonly type = '[Dashboard] SaveWidget';

  constructor(public dashboardId: number, public widget: any, public payload: any) {
  }
}

export class MoveWidget {
  static readonly type = '[Dashboard] MoveWidget';

  constructor(public widget: Widget, public toDashboardId: number) {
  }
}


export class DuplicateDashboard {
  static readonly type = '[Dashboard] DuplicateDashboard';

  constructor(public widget: Widget) {
  }
}
